import { useTranslation } from 'react-i18next';
export const useTranslations = () => useTranslation('translations');
